import { Trans } from "@lingui/react";
import { i18n } from "@lingui/core";
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import $switchCaseDefault from 'dolla-switch';
import { ASPECT_RATIO, DEFAULT_IFRAME_HEIGHT, DEFAULT_IFRAME_WIDTH, getDesignEmbedIframeText, getEmbedIFrameTextPresentationAndVideo } from '@prezi/viewer-common';
import { InputGroup } from '@prezi/bento';
import { CopyTextArea } from '@prezi/common-components';
import { getGlassboxLogger } from '../../glassboxLogger';
import { SchemaVersion } from '../../api/presentation';
import { selectDocument, selectUnifiedPrivacy } from '../../store';
import { Dumb as Atoms } from '../atoms';
import { Dumb as Molecules } from '../molecules';
import * as Organisms from '../organisms';
import { isNil } from 'ramda';
import { localI18n } from '../../i18n';
import { actions } from '../../store/actions/actions';
import { documentToDocumentType } from '../../utils/mappings';
const uxCopy = {
  header: localI18n._("Embed")
};
function getEmbedIframeText({
  embedLink,
  viewToken,
  height,
  width,
  schemaVersion
}) {
  return $switchCaseDefault(schemaVersion, {
    [SchemaVersion.INFOGRAM]: () => getDesignEmbedIframeText(viewToken, height.toString(), width.toString())
  }, () => getEmbedIFrameTextPresentationAndVideo(embedLink, height.toString(), width.toString()));
}
const InputGrid = styled(Atoms.ColumnGrid).withConfig({
  displayName: "EmbedPage__InputGrid",
  componentId: "ghtf58-0"
})(["grid-template-columns:80px 80px;margin-bottom:24px;&&{column-gap:20px;}"]);
const DesignExplanationContainer = styled.div.withConfig({
  displayName: "EmbedPage__DesignExplanationContainer",
  componentId: "ghtf58-1"
})(["margin-bottom:8px;"]);
const DimensionsSectionDesign = () => React.createElement(DesignExplanationContainer, null, React.createElement(Trans, {
  id: "The embedded view will adjust to its container and will adapt to the viewer's screen size."
}), ' ', React.createElement("a", {
  href: "https://support.prezi.com/hc/en-us/articles/360053442394-Embedding-your-Prezi-Design-content"
}, React.createElement(Trans, {
  id: "Read more"
})));
const EmbedPage = ({
  onBack
}) => {
  const dispatch = useDispatch();
  const {
    value: document
  } = useSelector(selectDocument);
  const schemaVersion = document === null || document === void 0 ? void 0 : document.schema_version;
  const {
    value: unifiedPrivacy
  } = useSelector(selectUnifiedPrivacy);
  const embedLink = unifiedPrivacy === null || unifiedPrivacy === void 0 ? void 0 : unifiedPrivacy.embed_link;
  const viewToken = unifiedPrivacy === null || unifiedPrivacy === void 0 ? void 0 : unifiedPrivacy.view_token;
  const [width, setWidth] = React.useState(parseInt(DEFAULT_IFRAME_WIDTH, 10));
  const [height, setHeight] = React.useState(parseInt(DEFAULT_IFRAME_HEIGHT, 10));
  useEffect(() => {
    if (document) {
      getGlassboxLogger().logOpenEmbedShare({
        prezi_oid: document.oid,
        document_type: documentToDocumentType(document)
      });
    }
  }, [document]);
  return React.createElement(Atoms.InnerScreenGrid, null, React.createElement(Molecules.Header, {
    onBack: onBack
  }, uxCopy.header), schemaVersion === SchemaVersion.INFOGRAM ? React.createElement(DimensionsSectionDesign, null) : React.createElement(InputGrid, null, React.createElement(InputGroup, {
    label: i18n._("Width"),
    type: "number",
    value: width.toString(),
    onChange: e => {
      const newWidth = parseInt(e.target.value, 10);
      const newHeight = Math.round(newWidth * (1 / ASPECT_RATIO));
      setWidth(newWidth);
      setHeight(newHeight);
    }
  }), React.createElement(InputGroup, {
    label: i18n._("Height"),
    type: "number",
    value: height.toString(),
    onChange: e => {
      const newHeight = parseInt(e.target.value, 10);
      const newWidth = Math.round(newHeight * ASPECT_RATIO);
      setWidth(newWidth);
      setHeight(newHeight);
    }
  })), !isNil(embedLink) && !isNil(viewToken) && !isNil(schemaVersion) && React.createElement("div", null, React.createElement(CopyTextArea, {
    buttonLabel: React.createElement(Trans, {
      id: "Copy"
    }),
    linkUrl: getEmbedIframeText({
      embedLink,
      viewToken,
      width,
      height,
      schemaVersion
    }),
    rows: 4,
    onCopy: () => dispatch(actions.logOpenCopyEmbedCode())
  })), React.createElement(Organisms.Smart.FooterSimple, null));
};
export default EmbedPage;